import { UserRightsMessages, TranslationUserRightsMessages } from "../interfaces/userRightsMessages";

export const messages: TranslationUserRightsMessages = {
  [UserRightsMessages.launcher]: "Inicio",
  [UserRightsMessages.rightsControl]: "Control de derechos",
  [UserRightsMessages.selectTenant]: "Seleccionar inquilino",
  [UserRightsMessages.userControl]: "Control de usuario",
  [UserRightsMessages.roleDashboardTabCaption]: "Grupos",
  [UserRightsMessages.roleDashboardPageTitle]: "Control de derechos de usuario",
  [UserRightsMessages.createRoleTabCaption]: "Crear grupo",
  [UserRightsMessages.editRoleTabCaption]: "Editar grupo",
  [UserRightsMessages.createUserTabCaption]: "Crear usuario",
  [UserRightsMessages.editUserTabCaption]: "Editar usuario",
  [UserRightsMessages.usersWithoutRole]: "Usuarios sin grupo",
  [UserRightsMessages.noRoleOrUserRegistered]: "Ningún grupo o usuario registrado",
  [UserRightsMessages.noSuiteAllowed]: "No tienes acceso al control de derechos de usuario de la suite Topcon",
  [UserRightsMessages.memberCount]: "{{count}} miembros",
  [UserRightsMessages.userCount]: "{{count}} usuarios"
};